import { render, staticRenderFns } from "./BetaPill.vue?vue&type=template&id=6dcaeb96"
import script from "./BetaPill.vue?vue&type=script&lang=js"
export * from "./BetaPill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports